/** The RP_ENV_TYPE string value for the production namespace. */
export const PRODUCTION_ENV = 'production';
const DEVELOPMENT_ENV = 'development';
const KUBERNETES_STAGING_ENV = 'kubernetes_staging';

const namespaces = [PRODUCTION_ENV, DEVELOPMENT_ENV, KUBERNETES_STAGING_ENV] as const;

export type Namespace = (typeof namespaces)[number];

export function getNamespace(): Namespace {
  const envType: Namespace | undefined =
    typeof process !== 'undefined' ? (process.env?.RP_ENV_TYPE as Namespace) : undefined;
  if (envType && namespaces.includes(envType)) {
    return envType;
  }
  return 'development';
}
